<template>
  <div class="my-2">
    <!-- <div v-if="isLoading">
          <Spinner />
        </div> -->

    <!-- <h3 class="text-lg leading-6 font-medium text-gray-900 mt-5">
              Email Stats
            </h3> -->
    <div v-if="isLoading" class=" grid grid-cols-1 gap-5 sm:grid-cols-3">
      <div
        v-for="i in 4"
        :key="i"
        class="bg-gray-100 overflow-hidden shadow rounded-lg"
        style="min-height: 128px;"
      >
        <div class="px-4 py-5 sm:p-6 animate-pulse">
          <div class="h-4 bg-gray-200 rounded w-1/2 mb-4"></div>
          <div class="h-8 bg-gray-200 rounded w-1/4"></div>
        </div>
      </div>
    </div>

    <div v-else class="grid grid-cols-1 gap-5 sm:grid-cols-3">
      <div
        class="bg-white overflow-hidden shadow rounded-lg"
        style="min-height: 128px;"
      >
        <div class="px-4 py-5 sm:p-6">
          <dl>
            <dt class="text-sm leading-5 font-medium text-gray-500 ">
              Mails Sent
            </dt>
            <dd class="mt-1 text-3xl leading-9 font-semibold text-gray-900">
              {{ report.mailsSent || 0 }}
            </dd>
          </dl>
        </div>
      </div>

      <div
        class="bg-white overflow-hidden shadow rounded-lg"
        style="min-height: 128px;"
      >
        <div class="px-4 py-5 sm:p-6">
          <dl>
            <dt class="text-sm leading-5 font-medium text-gray-500 ">
              New Reviews - Last 30 days
            </dt>
            <dd class="mt-1 text-3xl leading-9 font-semibold text-gray-900">
              {{ report.newReviews || 0 }}
            </dd>
          </dl>
        </div>
      </div>
      <div
        class="bg-white overflow-hidden shadow rounded-lg"
        style="min-height: 128px;"
      >
        <div class="px-4 py-5 sm:p-6">
          <dl>
            <dt class="text-sm leading-5 font-medium text-gray-500 ">
              Negative Customer Feedback
            </dt>
            <dd class="mt-1 text-3xl leading-9 font-semibold text-gray-900">
              {{ report.feedback || 0 }}
            </dd>
          </dl>
        </div>
      </div>
      <div
        class="bg-white overflow-hidden shadow rounded-lg"
        style="min-height: 128px;"
      >
        <div class="px-4 py-5 sm:p-6">
          <dl>
            <dt class="text-sm leading-5 font-medium text-gray-500 ">
              Scheduled Mails
            </dt>
            <dd class="mt-1 text-3xl leading-9 font-semibold text-gray-900">
              {{ report.scheduledMails || 0 }}
            </dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import { subDays, format, startOfMonth, endOfMonth } from "date-fns";

export default {
  name: "Analytics",
  components: {},
  data() {
    return {
      pageTitle: "Overview",
      report: {
        mailsSent: 0,
        newReviews: 0,
        feedback: 0,
        scheduledMails: 0
      },
      cartReport: {},
      automationReport: {},
      subscriberReport: {},
      urlReport: {},
      clickedCount: {},
      currentConfig: {
        startDate: "",
        endDate: ""
      },
      ranges: {},
      isLoading: false
    };
  },
  computed: {
    dateDiff() {
      const startDate = this.currentConfig.startDate;
      const endDate = this.currentConfig.endDate;

      if (startDate && endDate) {
        return `${format(startDate, "dd MMM yyyy")} - ${format(
          endDate,
          "dd MMM yyyy"
        )}`;
      }
      return "";
    },
    config() {
      return this.$store.getters.getConfig;
    }
  },
  async created() {
    // Initialize data fetching earlier in the lifecycle
    this.getReport();

    let today = new Date();
    today.setHours(0, 0, 0, 0);

    let yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);
    yesterday.setHours(0, 0, 0, 0);
    this.ranges = {
      Today: [today, today],
      Yesterday: [yesterday, yesterday],
      "This month": [startOfMonth(today), endOfMonth(today)],

      "Last month": [
        new Date(today.getFullYear(), today.getMonth() - 1, 1),
        new Date(today.getFullYear(), today.getMonth(), 0)
      ]
    };
  },
  mounted() {
    const startDate = subDays(new Date(), 7);
    this.currentConfig = {
      startDate: startDate,
      endDate: new Date()
    };
  },
  methods: {
    dateSelected() {
      this.getReport();
    },
    async getReport() {
      this.isLoading = true;

      const response = await this.$store.dispatch("getAnalytics");
      this.report = response;
      this.isLoading = false;
    }
  }
};
</script>

<style>
/* Add some fade-in transitions to make any changes appear smooth */
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
</style>
